import { connectHits } from 'instantsearch.js/es/connectors'
import { get } from '@bigyouth/base'
import moment from 'moment'

const renderHits = (renderOptions, isFirstRender) => {
  const { hits, widgetParams } = renderOptions

  if (hits.length !== 0) {
    widgetParams.container.innerHTML = '<ul class="row"></ul>'

    hits.forEach((hit) => {
      // create li element, add classes
      const li = document.createElement('li')
      li.classList.add('col-12')
      li.classList.add('md-col-6')
      li.classList.add('lg-col-4')
      li.classList.add('mb-6')
      li.classList.add('flex')

      const format = hit.locale === 'en' ? 'ddd MM/DD/YY' : 'ddd DD/MM/YY'
      const startDate = hit.startDate
        ? moment(new Date(hit.startDate.date))
          .locale(config.locale)
          .format(format)
        : ''
      const endDate = hit.endDate
        ? moment(new Date(hit.endDate.date))
          .locale(config.locale)
          .format(format)
        : ''

      const hasLocation =
        (hit.address !== null && hit.address !== undefined) ||
        (hit.zipCode !== null && hit.zipCode !== undefined) ||
        (hit.city !== null && hit.city !== undefined) ||
        (hit.country !== null && hit.country !== undefined)

      li.innerHTML = `
      <div class="event-card w-full">
        <div>
          <div class="flex flex-wrap">
            ${
              hit.thematics
                ? hit.thematics
                    .map((thematic) => {
                      return `<a href="${thematic.url}" class="thematic thematic--dark-blue mr-1 mb-2">${thematic.name}</a>`
                    })
                    .join('')
                : ''
            }
          </div>
          <span class="event-card__title title-4 title-4--medium title-4--white mt-2 block">${
            hit.title
          }</span>
          <div class="mt-6">
            <div class="flex items-center mb-2">
              <svg width="28" height="28" class="flex-shrink-0 mr-4 icon icon--dark-blue">
                <use href="#icon-calendar" xlink:href="#icon-calendar"></use>
              </svg>
              <span class="event-card__info">
                ${
                  startDate === endDate
                    ? startDate
                    : `${config.trads['list.event.from']} ${startDate} ${config.trads['list.event.to']} ${endDate}`
                }
              </span>
            </div>
            ${
              hit.time && hit.time !== null
                ? `<div class="flex items-center mb-2">
                  <svg width="28" height="28" class="flex-shrink-0 mr-4 icon icon--dark-blue">
                    <use href="#icon-hour" xlink:href="#icon-hour"></use>
                  </svg>
                  <span class="event-card__info">${hit.time}</span>
                </div>`
                : ''
            }
            <div class="flex items-center mb-2">
              <svg width="28" height="28" class="flex-shrink-0 mr-4 icon icon--dark-blue">
                <use href="#icon-method2" xlink:href="#icon-method2"></use>
              </svg>
              <span class="event-card__info">${hit.eventType}</span>
            </div>
            ${
              hit.eventType !== 'En distanciel' &&
              hit.eventType !== 'Remote' &&
              hit.eventType !== 'A distancia' &&
              hasLocation
                ? `<div class="flex items-center mb-8">
                  <svg width="28" height="28" class="flex-shrink-0 mr-4 icon icon--dark-blue">
                    <use href="#icon-location3" xlink:href="#icon-location3"></use>
                  </svg>
                  <span class="event-card__info">${
                    hit.address !== null && hit.address !== undefined
                      ? `${hit.address} ${
                          (hit.zipCode !== null && hit.zipCode !== undefined) ||
                          (hit.city !== null && hit.city !== undefined) ||
                          (hit.country !== null && hit.country !== undefined)
                            ? ','
                            : ''
                        }`
                      : ''
                  } ${
                    hit.zipCode !== null && hit.zipCode !== undefined
                      ? hit.zipCode
                      : ''
                  }${
                    hit.city !== null && hit.city !== undefined
                      ? `${
                          hit.zipCode !== null && hit.zipCode !== undefined
                            ? ' '
                            : ''
                        }${hit.city}`
                      : ''
                  }${
                    hit.country !== null &&
                    hit.country !== undefined &&
                    ((hit.zipCode !== null && hit.zipCode !== undefined) ||
                      (hit.city !== null && hit.city !== undefined))
                      ? ','
                      : ''
                  } ${
                    hit.country !== null && hit.country !== undefined
                      ? hit.country
                      : ''
                  }</span>
                </div>`
                : ''
            }
          </div>
        </div>
        <div class="md:flex md:justify-between items-center md:flex-wrap event-card__bottom -mb-6">
          <a onclick="_paq.push(['trackEvent', 'Click', 'Voir l'évènement', '${hit.title}'])"
           class="cta cta--white pb-8 mr-5 mb-6" href="${hit.path}">
           ${config.trads['list.event.see']}
           </a>
          ${
            hit.cta !== undefined && hit.cta.label !== null && hit.cta.external !== null
              ? `<a url-space-treatment
                  onclick="_paq.push(['trackEvent', 'Click', '${hit.cta.label}', '${hit.title}'])"
                  href="${hit.cta.external.replace(/\+/g, '%20')}"
                  target="${hit.cta.target}" 
                  class="button button--small button--light-blue mb-6">
                <svg class="icon icon--light-blue">
                    <use href="#icon-subscription" xlink:href="#icon-subscription"></use>
                </svg>
                ${hit.cta.label}
              </a>`
              : ''
          }
        </div>
      </div>
      `

      get('ul', widgetParams.container).appendChild(li)
    })
  } else {
    widgetParams.container.innerHTML = config.trads['list.event.empty']
  }
}

const customHitsEvents = connectHits(renderHits)

export default customHitsEvents
